import { SVGProps, memo } from 'react';

const OnBoardingCheckBox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.0693 1.94922C13.1739 1.94922 14.0693 2.84465 14.0693 3.94922V12.2002C14.0691 13.3046 13.1738 14.2002 12.0693 14.2002H3.89453C2.79008 14.2002 1.89472 13.3046 1.89453 12.2002V3.94922C1.89453 2.84465 2.78996 1.94922 3.89453 1.94922H12.0693ZM6.52539 9.72363L4.63477 7.83984L3.59375 8.87305L6.52539 11.7969L12.3877 5.93457L11.3545 4.89453L6.52539 9.72363Z'
      fill='#2542FB'
    />
  </svg>
);

export default memo(OnBoardingCheckBox);
